/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Subtract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Subtract"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M21 11.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1 0-3h15a1.5 1.5 0 0 1 1.5 1.5"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const SubtractIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'subtract-icon'}
      icon={Subtract}
      {...props}
      size={size}
    />
  );
};
